import { useMutation } from '@tanstack/react-query';
import { NumberInlineEditor } from 'components/inline_edit/NumberInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationMaxTransportUpdateCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: updateMaxOilQuality, isPending } = useMutation({
        mutationFn: (maxTransportUpdate: number | undefined) =>
            updateLocation(rowData, { MaxTransportInterval: maxTransportUpdate }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location max transport update interval',
            }),
    });

    return (
        <NumberInlineEditor
            value={rowData.Settings.MaxTransportInterval}
            isDisabled={isPending || !canEditLocationDetails}
            onConfirm={(val) => updateMaxOilQuality(val)}
            validate={(val) => {
                if (val === undefined) {
                    return 'Location max transport is required';
                }
                if (val <= 0) {
                    return 'Location max transport must be greater than 0';
                }
                return undefined;
            }}
        />
    );
}
